import { useForm } from "react-hook-form";
import { Input } from "../ui/input";
import { ChangeDbName, IAppResponse } from "@/controllers/appController";
import { forwardRef, useContext } from "react";
import { Button } from "../ui/button";
import { AppContext } from "../Context/AppContext";
import { toast } from "sonner";

interface FormValues {
    name: string;
};

interface ChangeDbFormProps {
    appName: string
    setIsOpen: (arg: boolean) => void;
}

export const ChangeDbForm = forwardRef<HTMLButtonElement, ChangeDbFormProps>(({ appName, setIsOpen }, ref) => {
    const { register, handleSubmit, reset } = useForm<FormValues>();
    const { token } = useContext(AppContext)

    async function onSubmit(data: FormValues) {
        setIsOpen(false)
        reset();
        const response: IAppResponse = await ChangeDbName(appName, data.name, token);
        if (response.result) {
            toast.success("Banco de dados alterado")
            return
        }
        toast.error(response.error)
    }

    return (
        <form className="space-y-8 w-full" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex w-full h-full items-center space-x-2">
                <Input
                    id="name"
                    placeholder="Nome"
                    required
                    {...register("name")}
                />
                <Button type="submit" ref={ref}>Alterar</Button>
            </div>
        </form>
    );
});

